export default __webpack_public_path__ + "37a779d7f5b8641e246939d46c6e94a3.png";